import React from "react";
import { Alert } from "antd";

const AlertComponent = ({ message, error }) => {
  return <Alert message={message} type={error ? "error" : "success"} />;
};

export default AlertComponent;
